module.exports = __webpack_public_path__ + "static/media/BALL.aaddcac3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/BALL.png
// module id = 245
// module chunks = 0